<template>
  <div>
    <select
      class="form-control"
      @change="onChanged($event)"
      :disabled="disabled"
    >
      <option value="-1" :selected="selectedVal == -1"
        >---{{ $t("messages.general.notSpecified") }}---</option
      >
      <option
        v-for="(item, index) in items"
        :key="index"
        :value="item.LEVELID"
        :selected="selectedVal == item.LEVELID"
      >
        {{ item.LEVELNAME }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MasterDataProvider from "@/services/masterData_provider";

const masterDataProvider = new MasterDataProvider();

export default {
  name: "Level",
  props: {
    onChanged: Function,
    selectedVal: Number,
    disabled: { type: Boolean, default: true }
  },
  data: () => {
    return {
      items: []
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("application", ["togglePreLoader"]),
    async loadData() {
      this.togglePreLoader(true);
      this.items = await masterDataProvider.getLevel({
        token: this.token,
        lang: this.currentLang
      });
      this.togglePreLoader(false);
    }
  },
  watch: {
    currentLang() {
      this.loadData();
    }
  }
};
</script>
